import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardContent, CardHeader, Typography, Divider, Grid } from "@mui/material";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";

import MappingToolBar from "../../../../components/MappingToolbar";
import MapPlanModal from "./MapPlanModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import CustomTextField from "../../../../components/CustomTextField";
import InternetPlanTable from "./InternetPlanTable";

const AllowedPlan = ({ planGroupId, isSharingAllowed, serviceType, validationFields }) => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();
  const { openDialog } = useDialog();
  const { t } = useTranslation();

  const sharingType = watch("sharingType");
  const msoSharing = watch("msoSharing");
  const distSharing = watch("distSharing");
  const lcoSharing = watch("lcoSharing");
  const planGroupPlans = watch("planGroupPlans");

  const msoSharingName = msoSharing + "%";
  const distSharingName = distSharing + "%";
  const lcoSharingName = lcoSharing + "%";
  const openDownloadDialog = () => {
    return openDialog(
      "map_plan_modal",
      "Map Plan Modal",
      <MapPlanModal
        planGroupId={planGroupId}
        key={getTimeStamp()}
        isNew={true}
        isSharingAllowed={isSharingAllowed}
        multiple={sharingType == "FIXED"}
        sharingType={sharingType}
        msoSharing={msoSharing}
        distSharing={distSharing}
        lcoSharing={lcoSharing}
        serviceType={serviceType}
        setPlanGroupPlanValues={setValue}
        planGroupPlans={planGroupPlans}
      />,
      "lg",
    );
  };

  useEffect(() => {
    if (sharingType == "FIXED") {
      const updatedPlans = planGroupPlans.map((plan) => ({
        ...plan, // keep existing planId or other fields
        msoSharing,
        distSharing,
        lcoSharing,
        msoSharingName,
        distSharingName,
        lcoSharingName,
      }));
      setValue("planGroupPlans", updatedPlans);
    }
  }, [msoSharing, distSharing, lcoSharing]);

  return (
    <Card mb={6}>
      <CardHeader action={<MappingToolBar openDialog={openDownloadDialog} />} />

      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t("Sharing")}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={12} className="row" pt={8}>
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("mso_sharing")}
                name="msoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("dist_sharing")}
                name="distSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("lco_sharing")}
                name="lcoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
        </Grid>

        <InternetPlanTable />
      </CardContent>
    </Card>
  );
};

export default AllowedPlan;
